'use strict';

var constants = require('./util/constants'),
    Logging   = require('./mixins/logging');

var Faye = {
  VERSION:    constants.VERSION,

  Client:     require('./protocol/client'),
  Scheduler:  require('./protocol/scheduler')
};

Logging.wrapper = Faye;

module.exports = Faye;



//////////////////
// WEBPACK FOOTER
// ./~/faye/src/faye_browser.js
// module id = 293
// module chunks = 0